import styled from 'styled-components';

import { ApproverMessage } from '../../../../types/ApproverMessage';
import { theme } from '../../../common/ui/theme';

import { ApproverLabel } from './ApproverLabel';

const TopLevelApproverList = styled.ul`
    // Override ul standards
    padding-left: ${theme.space[24]};
    margin-bottom: 0;
`;

interface TopLevelApproverProps {
    approver: ApproverMessage;
}

export const TopLevelApprover = ({ approver }: TopLevelApproverProps) => {
    return (
        <TopLevelApproverList>
            <li>
                <ApproverLabel approver={approver} />
            </li>
        </TopLevelApproverList>
    );
};
